import React from "react";
import styled from "styled-components";

import { AppIcon, QRCODE } from "icons";

import { Title } from "./NursingHomeRegistration";
import { useLocation } from "react-router-dom";

const Wrapper = styled.div`
  text-align: center;
`;

const Text = styled.div`
  font-family: Noto Sans JP;
  font-weight: 500;
  font-size: 16px;
  line-height: 19.2px;
  letter-spacing: 0px;
  text-align: center;
  color: #3b3b3b;
  margin-bottom: 8px;
`;

const SecondText = styled.div`
  font-family: Noto Sans JP;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #1a2f62;
  margin-bottom: 24px;
  text-align: left;
`;

const ThirdText = styled.a`
  font-family: Noto Sans JP;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #2f8cae;
  margin-bottom: 12px;
  &:hover,
  &:active {
    color: #2f8cae;
  }
`;

const WrapperImg = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;
  justify-content: center;
`;

const DownloadAppNQR: React.FC = () => {
  const { search } = useLocation();
  const superCityName = new URLSearchParams(search).get("name");

  return (
    <Wrapper>
      <Title>{superCityName}登録</Title>
      <Text>登録完了しました</Text>
      <SecondText>
        下記ボタンクリックか２次元コードの読み取り後、ご利用の端末にアプリをインストールし、登録した電話番号とパスワードにてご利用ください。
      </SecondText>
      <ThirdText href="https://leber.jp/our-product">
        医療相談アプリLEBERをダウンロード
      </ThirdText>

      <WrapperImg>
        <AppIcon />
        <QRCODE />
      </WrapperImg>
    </Wrapper>
  );
};

export default DownloadAppNQR;
